import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ContextCallUpdateAnalytics from "./components/ContextCallUpdateAnalytics";
import ThemeDefault from "./components/themes/theme_basic";
import ThemeSpecial from "./components/themes/theme_special";
import { SHOP } from "./config/config";
// import usePageViews from "./hooks/usePageViews";
import "./scss/index.scss";

const App = () => {
  const general = useSelector((state) => state.settings.general);
  const brandMark = useSelector((state) => state.settings.brandMark);
  const googleTranslateStyle = {
    display: general.googleTranslateExtension ? "block" : "none",
    left: general.googleTranslatePosition === "left" ? "10px" : "unset",
    right: general.googleTranslatePosition === "right" ? "10px" : "unset",
    zIndex: 100000000,
    backgroundColor: "#fff",
  };
  const [getShop, setGetShop] = useState(!SHOP ? window?.Shopify?.shop : SHOP);
  // update event analystic page view
  // console.log(getShop);
  // usePageViews(getShop);

  useEffect(() => {
    if (window?.Shopify?.shop) {
      setGetShop(window?.Shopify?.shop);
    } else {
      setGetShop(SHOP);
    }
  }, [window?.Shopify?.shop]);
  const [style, setStyle] = useState({
    __html: `
              .goog-te-banner-frame{visibility: hidden}
              `,
  });
  useEffect(() => {
    setStyle({
      __html: `
              .goog-te-banner-frame{visibility: hidden}
              `,
    });
  }, []);
  return (
    <>
      <ContextCallUpdateAnalytics />
      <div className="omg-theme">
        <div id="google_translate_element" style={googleTranslateStyle}></div>
        {!general.googleTranslateExtension && (
          <>
            <style
              dangerouslySetInnerHTML={{
                __html: `
              .skiptranslate{ display: none}
              `,
              }}
            />
            {window.dynamicReview && (
              <style
                dangerouslySetInnerHTML={{
                  __html: `
              #root{
                transform: translateY(-65px)
              }
              `,
                }}
              />
            )}
          </>
        )}
        <style dangerouslySetInnerHTML={style} />

        {general?.theme === 2 ? (
          <div className="omg-special">
            <ThemeSpecial shop={getShop} />
          </div>
        ) : (
          <div className="omg-default">
            <ThemeDefault shop={getShop} />
          </div>
        )}
        {brandMark && (
          <div
            className="ot-powered"
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "2rem",
            }}
          >
            <a
              className="ot-powered-content"
              style={{
                backgroundColor: "#0000000d",
                padding: "4px 8px",
                fontSize: 14,
                borderRadius: 14,
                cursor: "pointer",
                textDecoration: "none",
                color: "#000",
              }}
              href="https://synctrack.io/order-tracking/?utm_source=brandmark"
            >
              Powered by{" "}
              <span style={{ fontSize: "13px", fontWeight: 600 }}>
                Synctrack Order Tracking
              </span>
            </a>
          </div>
        )}
      </div>
    </>
  );
};

export default App;
